// Entry dates are plain calendar days (a Postgres `date`), not instants.
// Parsing them with `new Date('2026-01-01')` reads them as UTC midnight, which
// is the previous day west of Greenwich — so they are split by hand instead.

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

export function formatStubDate(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ''));
  if (!match) return '';

  const [, year, month, day] = match;
  const name = MONTHS[Number(month) - 1];
  if (!name) return '';

  return `${Number(day)} ${name} ${year}`;
}

export function todayISO() {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}
